const SCRIPT_SRC =
	'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
const SCRIPT_ID = 'cf-turnstile-script'

let scriptPromise = null

/**
 * Load the Cloudflare Turnstile script once for the whole app.
 * Safe to call from login and dashboard; does not block first paint.
 */
export function loadTurnstileScript() {
	if (window.turnstile) return Promise.resolve()
	if (scriptPromise) return scriptPromise

	scriptPromise = new Promise((resolve, reject) => {
		const existing = document.getElementById(SCRIPT_ID)
		if (existing) {
			if (window.turnstile) {
				resolve()
				return
			}
			existing.addEventListener('load', () => resolve(), { once: true })
			existing.addEventListener(
				'error',
				() => {
					scriptPromise = null
					reject(new Error('turnstile_script'))
				},
				{ once: true },
			)
			return
		}

		const script = document.createElement('script')
		script.id = SCRIPT_ID
		script.src = SCRIPT_SRC
		script.async = true
		script.defer = true
		script.onload = () => resolve()
		script.onerror = () => {
			scriptPromise = null
			reject(new Error('turnstile_script'))
		}
		document.head.appendChild(script)
	})

	return scriptPromise
}
